/**
 * Debug Configuration
 *
 * ═══════════════════════════════════════════════════════════════
 * ⚠️  PRODUCTION RELEASE CHECKLIST  ⚠️
 * ═══════════════════════════════════════════════════════════════
 *
 * Before building for production:
 *
 * 1. Set DEBUG_ENABLED = false  (line 22 below)
 *
 * 2. This completely removes from production:
 *    ✗ Debug menu
 *    ✗ Debug toggle button (🔧)
 *    ✗ Keyboard shortcuts (Ctrl+Shift+D)
 *    ✗ window.toggleDebugMenu() and window.clearGame()
 *
 * 3. Build: npm run build
 *
 * 4. Verify: Check that no debug button appears
 *
 * 5. Deploy: Upload /dist folder
 *
 * For development, keep DEBUG_ENABLED = true
 * ═══════════════════════════════════════════════════════════════
 */

// ⚠️ CHANGE THIS TO FALSE FOR PRODUCTION ⚠️
export const DEBUG_ENABLED = true;

/**
 * Debug keyboard shortcut
 * Default: Ctrl + Shift + D (or Cmd + Shift + D on Mac)
 */
export const DEBUG_SHORTCUT = {
  key: 'D',
  ctrl: true,
  shift: true,
  alt: false,
};

/**
 * Show debug toggle button in UI
 * Set to false to hide the button (keyboard shortcut will still work)
 */
export const SHOW_DEBUG_BUTTON = true;
